// watch/nowPlaying.ts — the watch page's playback clock for things beside the player that
// follow along (the transcript, 1.27.60). A store rather than page state, so the page does not
// re-render on every tick — only a subscriber whose selected value changed does.
import { create } from 'zustand';

export const useNowPlaying = create<{ t: number; setT: (t: number) => void }>((set) => ({
  t: 0,
  setT: (t) => set({ t }),
}));
